var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImagesConfirmImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 291.888,
    height: 220.255,
    viewBox: "0 0 291.888 220.255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 291.888,
    height: 220.255,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 291.887,
    height: 220.255,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 11.541,
    height: 15.068,
    transform: "translate(244.896 181.36)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 11.54,
    height: 15.065,
    transform: "translate(244.897 181.36)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 2.369,
    height: 5.44,
    transform: "translate(56.335 126.739)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 12.598,
    height: 9.378,
    transform: "translate(40.99 128.655)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 17.536,
    height: 7.298,
    transform: "translate(38.541 139.282)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 23.967,
    height: 23.967,
    transform: "translate(51.563 82.299)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.537,164.838C317.125,95.332,244.372-1.352,154.992.014,128.05.426,105.6,15.341,87.163,39.529,46.786,92.5,8.76,88.529.787,134.166s45.771,95.4,111.085,42.67c47.74-38.541,115.273,62.37,157.733,9.822a121.278,121.278,0,0,0,13.932-21.819",
    fill: "#eeeffa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.261,164.756l1.5-.2-1.385.836a15.729,15.729,0,0,0,3.327,6.771l.009.009c.558.612,2.68-.809,3.076-1.169,1.555-1.394,2.275-3.435,2.949-5.35.827-2.338,1.61-4.694,2.6-6.969.791-1.816,1.672-3.6,2.536-5.377l-.746-2.212,1.87-.189c.18-.4.351-.791.521-1.187.764-1.78,1.493-3.57,2.167-5.386-.333.117-9.064,3.4-14.351,8.866l.692,1.115-2.014.4a13.832,13.832,0,0,0-1.672,2.653,12.372,12.372,0,0,0-1.079,7.391",
    fill: "#bbbaf4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.971,159.72c.18.216.342.441.513.665a59.713,59.713,0,0,0,5.341,6.492l.953-.629s-.324.638-.521,1.07a63.833,63.833,0,0,0,5.35,4.972,7.579,7.579,0,0,0,1.754,1.142l.782-.836s-.018.6-.018,1.079a2.555,2.555,0,0,0,.872.027c.4-.054,1.816-.333,2.014-.719l.009-.009a7.612,7.612,0,0,0-1.735-8.084,7.748,7.748,0,0,0-1.25-1.043l-.612.791-1.025-1.726a24.96,24.96,0,0,0-2.967-1.133,47.842,47.842,0,0,0-6.717-1.628c-.908-.162-1.825-.3-2.742-.432",
    fill: "#bbbaf4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.5,175.9l.009.009c2.473,1.061,5.368.117,7.985-1.448-.342-.71-1.034-2.113-1.1-2.2s1.277.98,2.05,1.6a37.362,37.362,0,0,0,6.726-5.961s-9.9-.63-13.577,1.277a4.986,4.986,0,0,0-.944.638l.324.755-.827-.216c-1.744,2.221-.647,5.548-.647,5.548",
    fill: "#bbbaf4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.966,183.138s-3.424-21.3,9.056-33.309",
    fill: "none",
    stroke: "#31374c",
    strokeWidth: 1.019
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.491,186.17s-1.211-16.717-15.219-22.376",
    fill: "none",
    stroke: "#31374c",
    strokeWidth: 1.019
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.163,181.985s5.576-10.572,14.122-12.521",
    fill: "none",
    stroke: "#31374c",
    strokeWidth: 1.019
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.867,181.261l4.2,15.164h8.777l4.172-15.065a.245.245,0,0,0,.015-.053l.015-.046Z",
    fill: "#31374c"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.437,196.428h-7.369L244.9,181.363c.4,1.249,4.75,14.22,11.54,15.065",
    fill: "#8391fc"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M235.826,188.185l-142.571.263c-6.224.011-11.355-6.359-11.4-14.157L81.3,84.621c-.049-7.8,5-14.187,11.228-14.2L235.1,70.157c6.224-.011,11.355,6.359,11.4,14.157l.556,89.67c.048,7.8-5,14.187-11.228,14.2",
    fill: "#d2dbfa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.338,88.443l-.043-5.918c-.049-6.666,5-12.129,11.228-12.138l142.571-.225c6.224-.01,11.356,5.436,11.4,12.1l.043,5.917Z",
    fill: "#8194de"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.126,80.222a1.91,1.91,0,0,1-1.908,1.9,1.887,1.887,0,0,1-1.89-1.884v-.016a1.91,1.91,0,0,1,1.908-1.9,1.888,1.888,0,0,1,1.89,1.886v.014",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.083,80.222a1.91,1.91,0,0,1-1.908,1.9,1.888,1.888,0,0,1-1.89-1.886v-.014a1.911,1.911,0,0,1,1.908-1.9,1.888,1.888,0,0,1,1.89,1.886v.014",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.04,80.222a1.91,1.91,0,0,1-1.908,1.9,1.888,1.888,0,0,1-1.89-1.886v-.014a1.911,1.911,0,0,1,1.908-1.9,1.888,1.888,0,0,1,1.889,1.887v.013",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.589,203.608c0,2.925-32.036,5.3-71.555,5.3s-71.555-2.372-71.555-5.3,32.036-5.3,71.555-5.3,71.555,2.372,71.555,5.3",
    fill: "#dcddf2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.635,
    cy: 2.635,
    r: 2.635,
    transform: "translate(145.975 26.758)",
    fill: "none",
    stroke: "#2d4e73",
    strokeLinecap: "round",
    strokeWidth: 1.998
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.74,137.368a24.909,24.909,0,1,1-24.909-24.909,24.909,24.909,0,0,1,24.909,24.909",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.88,126.572,122.673,153.4a1.216,1.216,0,0,1-1.45.925l-.013,0L94.487,147.9a1.241,1.241,0,0,1-.9-1.491l8-34.591a1.216,1.216,0,0,1,1.45-.925l.013,0,19.1,4.591Z",
    fill: "#bab9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.354,143.231h0a1.5,1.5,0,0,1,.994-2.621,2.681,2.681,0,0,0,2.7-2.659q0-.07,0-.141l-.027-.8a2.931,2.931,0,0,0-2.892-2.816,1.576,1.576,0,0,1-1.172-2.628,2.82,2.82,0,0,0-.134-3.971l-.581-.566A2.789,2.789,0,0,0,168.3,127l-.011.011a1.567,1.567,0,0,1-2.651-1.1,2.932,2.932,0,0,0-2.892-2.817h-.795a2.681,2.681,0,0,0-2.7,2.659q0,.07,0,.141a1.5,1.5,0,0,1-2.578,1.079,2.789,2.789,0,0,0-3.944-.023l-.011.011-.543.562a2.82,2.82,0,0,0,.134,3.971,1.5,1.5,0,0,1-.994,2.621,2.681,2.681,0,0,0-2.7,2.659q0,.07,0,.141l.027.8a2.93,2.93,0,0,0,2.892,2.816,1.576,1.576,0,0,1,1.172,2.628,2.82,2.82,0,0,0,.134,3.971l.581.566a2.789,2.789,0,0,0,3.944.023l.011-.011a1.567,1.567,0,0,1,2.651,1.1,2.931,2.931,0,0,0,2.891,2.816h.8a2.681,2.681,0,0,0,2.7-2.659q0-.07,0-.141a1.5,1.5,0,0,1,2.578-1.079,2.789,2.789,0,0,0,3.944.023l.011-.011.543-.562a2.818,2.818,0,0,0-.134-3.97m-15.264-.952a7,7,0,0,1-.333-9.854,6.921,6.921,0,0,1,9.788,0l.028.028a7,7,0,0,1,.333,9.854,6.921,6.921,0,0,1-9.788,0l-.028-.028",
    fill: "#6b87e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.475,77.228a56.709,56.709,0,0,1,22.292,28.3",
    fill: "none",
    stroke: "#2d4e73",
    strokeLinecap: "round",
    strokeWidth: 1.707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.24,105.522a56.7,56.7,0,0,1,20.847-27.315",
    fill: "none",
    stroke: "#2d4e73",
    strokeLinecap: "round",
    strokeWidth: 1.707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.624,162.261a56.542,56.542,0,0,1-79.841,4.4q-1.735-1.554-3.339-3.247",
    fill: "none",
    stroke: "#2d4e73",
    strokeLinecap: "round",
    strokeWidth: 1.707
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.916,217.093c0,1.746-16.325,3.161-36.463,3.161s-36.462-1.413-36.462-3.161,16.325-3.161,36.463-3.161,36.463,1.415,36.463,3.161",
    fill: "#dcddf2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.817,
    height: 48.48,
    transform: "translate(27.72 167.381)",
    fill: "#dcddf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.637,202.4c-.432,2.851-.064,5.448-.156,7.5-.055,1.238-.358.51.948.983,1.607.581,1.667,2.84,2.355,1.5l2.983-10.968Z",
    fill: "#c95836",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.106,175.638s2.852-7.714-7.625-14.276c-1.582-.991-17.984-11.9-18.662-10.977-.746,1.017-11.331.638-11.072,1.282,4.323,10.719,27.963,26.139,27.963,26.139Z",
    fill: "#667bc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.324,176.491s1.225-4.857-3.7-9.82c-5.489-5.529-16.6-13.446-17.373-12.614-.849.913-9.656,12.881-9.215,13.219,6.194,4.759,19.838,11.862,19.838,11.862Z",
    fill: "#667bc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.158,176.4c.257,1.693-10.179,29.974-10.179,29.974l-7.107-.178s-.972-27.793,9.734-34.071c0,0,7.421,3.406,7.552,4.275",
    fill: "#667bc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.053,202.4c-.264,2.851.261,5.448.291,7.5.018,1.238-.329.51,1.01.982,1.648.581,1.844,2.84,2.455,1.5l2.34-10.968Z",
    fill: "#c95836",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.515,210.11l3.206,2.49c.651.62,4.365,1.757,4.365,1.757.323.784-.447,1.224-1.083,1.346l-11.2.082s-2.552-.467.1-5.544c1.978.847,3.972,1.442,4.613-.132",
    fill: "#4a2a1a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.537,210.11l1.565,2.177a31.57,31.57,0,0,0,3.62,2.233.965.965,0,0,1-.816,1.328l-9.079-.063s-2.552-.467.1-5.544c1.978.847,3.972,1.442,4.613-.132",
    fill: "#4a2a1a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1,175.633c.257,1.693-9.425,30.746-9.425,30.746l-7.107-.178S62.6,178.408,73.3,172.13c0,0,6.666,2.635,6.8,3.5",
    fill: "#667bc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.623,169.919c-.5-1.1-13.637-13.689-14.453-14.226l2.583-6.117.226-.989-1.786-.172-2.674-1.99-.723,1.663-12.025.414s-3.313,16.874,2.769,19.213,18.119,3.043,18.119,3.043c9.021,2.058,8.958,1.328,7.964-.838",
    fill: "#667bc4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.475,175.282s.076-4.154-1.057-5.816-7.78-7.478-7.554-7.4",
    fill: "none",
    stroke: "#4e5794",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.55
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9,137.294c5.82.195,8.051-.006,13.9.056l.485,2.49c-11.756,1.634-13.4,5.009-18.128,3.215-1.8-5.063,2.391-5.5,3.743-5.761",
    fill: "#f9bbaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.673,140l2.837.764a2.454,2.454,0,0,0,1.7-.157l2.144-1.029a1.187,1.187,0,0,0,.307-1.926l-3.619-.759a3.694,3.694,0,0,0-2.487.411l-1.333.719Z",
    fill: "#f9bbaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.221,141.486l-.63-5.774-5.256-1.419-5.083-10.807a9.521,9.521,0,0,0-3.839-4.221,2.52,2.52,0,0,0-1.1-.416c-.932.063-1.757,6-1.757,6L57.982,139.2s-2.277,6.146,1.324,5.978c2.2-.1,11.916-3.7,11.916-3.7",
    fill: "#dd5e57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.289,118.83l-5.376-2-6.451.034-5.615,1.987c-3.94,1.614-4.741,5.535-5.112,8.79l.138,6.146c-.265,7.674-1.213,11.873-2.2,19.1,10.37,4.606,24.869,4.194,28.874-.561-.94-18.17-.007-24.5-4.261-33.493",
    fill: "#dd5e57",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,117.22s2.292,5.5-1.824,5.85-5.713-6.217-5.713-6.217l2.186-1.029,2.532-.1Z",
    fill: "#f9bbaa"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.466,132.179a.237.237,0,0,1-.222-.153l-1.893-4.964a.238.238,0,0,1,.444-.169l1.892,4.964a.237.237,0,0,1-.137.306.225.225,0,0,1-.085.016",
    fill: "#dd5e57"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.215,138.335l19.427-.27-.02-1.47-17.957.25A1.47,1.47,0,0,0,56.215,138.335Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.715,139.069c5.323-2.361,7.244-3.514,12.536-6.007L60.67,135.2c-9.869,6.593-11.777,10.24-16.813,10.684-3.823-3.774-.247-6,.858-6.816",
    fill: "#f9bbaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.254,133.077l2.815-.843a2.454,2.454,0,0,1,1.7.109l2.172.969a1.186,1.186,0,0,1,.36,1.917l-3.6.86a3.693,3.693,0,0,1-2.5-.342l-1.352-.682Z",
    fill: "#f9bbaa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.25,137.3l-2.355-4.08-10.255,4.6-7.751-12.537a7.491,7.491,0,0,0-1.843-1.968c-.616-.393-.536,2.416-.467,5.184a28.274,28.274,0,0,0,1.688,7.185l3.088,8.993s2.643,4.107,6.31,1.363,11.584-8.74,11.584-8.74",
    fill: "#dd5e57",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.362,138.033a.237.237,0,0,1-.211-.128l-1.8-3.471-2.34-5.447a.237.237,0,0,1,.435-.185l2.332,5.431,1.69,3.255,7.778-3.586a.238.238,0,0,1,.2.431l-7.989,3.683a.228.228,0,0,1-.1.022",
    fill: "#dd5e57"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.739,138.244l18.409-.256,5.384-12.456-17.987.25a.653.653,0,0,0-.589.393Z",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.453,138.234l18.409-.256L87,126.1a.4.4,0,0,0-.2-.529.392.392,0,0,0-.178-.036l-17.523.244a.4.4,0,0,0-.365.244Z",
    fill: "#4a2a1a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.682,131.965c-.208.775.4,1.393,1.354,1.379a2.249,2.249,0,0,0,2.108-1.427c.209-.775-.4-1.393-1.354-1.379a2.249,2.249,0,0,0-2.108,1.427",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.408,146.58a3.64,3.64,0,0,1-2.44-1.223,19.638,19.638,0,0,1-3.4-5.257l-.027-.059.212-.1-.057-.236c.19-.046.267.121.3.2a19.2,19.2,0,0,0,3.3,5.116c1.09,1.058,2.089,1.348,2.967.858,4.673-2.6,10.381-6.512,10.438-6.551a.238.238,0,0,1,.269.392c-.058.039-5.783,3.963-10.476,6.575a2.213,2.213,0,0,1-1.089.29",
    fill: "#dd5e57"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.147,119.771l-3.459-.724,1.4-11.324,4.278,3s.689,7.09-2.218,9.052",
    fill: "#3b1c17",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.736,109.168s2.109,7.34-1.076,8.775a5.979,5.979,0,0,1-1.076.207,7.236,7.236,0,0,0,.9-5.031c-.66-2.6-.382-3.054-.382-3.054Z",
    fill: "#3b1c17",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9,111.6s2.109,7.34-1.076,8.775a5.979,5.979,0,0,1-1.076.207,7.236,7.236,0,0,0,.9-5.031c-.66-2.6-.382-3.053-.382-3.053Z",
    fill: "#3b1c17",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.022,105.538s3.028-1.271,3.4,6.714c.253,5.436-6.869-2-6.869-2Z",
    fill: "#3b1c17",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.027,112.627l-1.265,6.044a2.083,2.083,0,0,1-1.355,1.555,1.909,1.909,0,0,1-1.949-.437l-.492-.476a2.671,2.671,0,0,1-.663-2.723l2.225-7.043Z",
    fill: "#f9bbaa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.746,114.119,50.27,116.1c-1.363-.5-2.044-1.841-2.581-3.357Z",
    fill: "#8f3e26",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.087,108.836a1.715,1.715,0,0,1,1.31-2l3.092-.618a1.732,1.732,0,0,1,1.906,1.354,18.969,18.969,0,0,1,.573,4.988,2.077,2.077,0,0,1-1.44,2.094c-.948.189-3.957-.184-4.545-1.895a25.27,25.27,0,0,1-.9-3.927",
    fill: "#f9bbaa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.48,111.941l-1.548.276s.2,1.1.933.871.615-1.147.615-1.147",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.759,106.128s-1.942,4.793-3.736,5.143c-.922.18-.908,1.514-1.637,2-1.32.887-3.385-2.805-3.056-4.361.484-2.293,1.139-3.145,3.858-4.089,1.66-.576,3.6-1.315,4.571,1.3",
    fill: "#3b1c17",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.855,107.214s-5.629,10.1-.408,12.377c0,0,3.591,1.343,3.417,1.236a6.448,6.448,0,0,1-1.006-2.677l1.83.9a7.484,7.484,0,0,1-.855-6.749c1.423-3.683.855-3.135.855-3.135Z",
    fill: "#3b1c17",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.753,112.712a1.216,1.216,0,0,0,1.6.627l.039-.018a1.338,1.338,0,0,0,.278-1.8,1.216,1.216,0,0,0-1.6-.627l-.039.018a1.339,1.339,0,0,0-.277,1.8",
    fill: "#f9bbaa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.968,114.619s-.386,2.777-1.73,3.1c0,0,1.69.5,2.133-.507",
    fill: "none",
    stroke: "#26120f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.877,118.006a3.515,3.515,0,0,1-2.108-2.757",
    fill: "none",
    stroke: "#26120f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.762,126.224l-6.192,26.257a1.213,1.213,0,0,1-1.459.9L95.454,147.1a1.213,1.213,0,0,1-.9-1.459l7.984-33.859a1.214,1.214,0,0,1,1.46-.9l19.057,4.494Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.762,126.224l-6.192,26.257a1.213,1.213,0,0,1-1.459.9L95.454,147.1a1.213,1.213,0,0,1-.9-1.459l7.984-33.859a1.214,1.214,0,0,1,1.46-.9l19.057,4.494Z",
    fill: "none",
    stroke: "#e6edfc",
    strokeWidth: 1.107
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.981,124.153l8.782,2.071-6.712-10.851Z",
    fill: "#e6edfc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.475,
    height: 19.721,
    transform: "translate(102.183 134.929) rotate(-76.717)",
    fill: "#e6edfc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.475,
    height: 19.721,
    transform: "translate(101.23 138.972) rotate(-76.717)",
    fill: "#e6edfc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.475,
    height: 19.721,
    transform: "translate(100.276 143.015) rotate(-76.717)",
    fill: "#e6edfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.417,134.361l-16.841-3.971a1.209,1.209,0,0,1-.9-1.454l1.154-4.893a1.209,1.209,0,0,1,1.454-.9l16.841,3.971a1.209,1.209,0,0,1,.9,1.454l-1.154,4.893a1.209,1.209,0,0,1-1.454.9",
    fill: "#dd5e57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.774,127.806a1.023,1.023,0,0,1-.512.3,1.5,1.5,0,0,1-.737-.014l-.515-.121-.289,1.226-.832-.2.805-3.416,1.348.318a1.6,1.6,0,0,1,.658.3,1,1,0,0,1,.331.491,1.166,1.166,0,0,1,.008.6,1.139,1.139,0,0,1-.265.511m-.774-.421a.5.5,0,0,0,.15-.634.511.511,0,0,0-.33-.195l-.452-.107-.2.857.453.106a.513.513,0,0,0,.381-.027",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.9,127.035a1.568,1.568,0,0,1,.483.749,1.818,1.818,0,0,1,.01.945,1.8,1.8,0,0,1-.431.838,1.544,1.544,0,0,1-.77.455,2.045,2.045,0,0,1-.992-.008l-1.279-.3.8-3.416,1.282.3a2.046,2.046,0,0,1,.893.437m-.788,2.163a1.009,1.009,0,0,0,.436-.669.939.939,0,0,0-.763-1.233l-.394-.093-.468,1.986.394.093a1.033,1.033,0,0,0,.795-.084",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.493,127.655l-.157.667-1.393-.328-.17.72,1.042.246-.152.647-1.042-.246-.326,1.382-.832-.2.806-3.416Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.106,56.4l16,21.717a1.213,1.213,0,0,1-.253,1.7l0,0L160.806,96.059a1.214,1.214,0,0,1-1.7-.254l0,0-20.638-28a1.213,1.213,0,0,1,.253-1.7l0,0,15.762-11.616Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.106,56.4l16,21.717a1.213,1.213,0,0,1-.253,1.7l0,0L160.806,96.059a1.214,1.214,0,0,1-1.7-.254l0,0-20.638-28a1.213,1.213,0,0,1,.253-1.7l0,0,15.762-11.616Z",
    fill: "none",
    stroke: "#e6edfc",
    strokeWidth: 1.107
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.837,61.749,167.1,56.4l-12.616-1.909Z",
    fill: "#e6edfc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.721,
    height: 1.475,
    transform: "translate(155.014 81.868) rotate(-36.386)",
    fill: "#e6edfc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.721,
    height: 1.475,
    transform: "translate(157.478 85.212) rotate(-36.386)",
    fill: "#e6edfc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19.721,
    height: 1.475,
    transform: "translate(159.942 88.556) rotate(-36.386)",
    fill: "#e6edfc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.9,129.05,223.354,153a1.085,1.085,0,0,1-1.293.826l-.013,0-23.858-5.735a1.108,1.108,0,0,1-.807-1.331l7.146-30.88a1.085,1.085,0,0,1,1.293-.826l.013,0,17.056,4.1Z",
    fill: "#bab9f8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.625,127.96l-5.541,23.948a1.085,1.085,0,0,1-1.293.826l-.013,0L199.921,147a1.109,1.109,0,0,1-.808-1.331l7.146-30.88a1.085,1.085,0,0,1,1.293-.826l.013,0,17.056,4.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.625,127.96l-5.541,23.948a1.085,1.085,0,0,1-1.293.826l-.013,0L199.921,147a1.109,1.109,0,0,1-.808-1.331l7.146-30.88a1.085,1.085,0,0,1,1.293-.826l.013,0,17.056,4.1Z",
    fill: "none",
    stroke: "#e3ecfd",
    strokeWidth: 1.247
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.766,126.071l7.86,1.889-6.007-9.9Z",
    fill: "#e3ecfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.664,131.326,198.9,128.018a1.79,1.79,0,0,1-1.3-2.15l.724-3.129a1.754,1.754,0,0,1,2.089-1.335l.021,0,13.764,3.307a1.791,1.791,0,0,1,1.3,2.151L214.776,130a1.753,1.753,0,0,1-2.089,1.335l-.021,0",
    fill: "#ffa600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.518,123.372l-.477,2.052-.5-.115.477-2.052Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.2,124l-.476,2.052-.5-.116.286-1.231-.745,1.124-.4-.093-.175-1.34-.287,1.233-.5-.116.477-2.052.59.137.246,1.553.9-1.288Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.447,126.065l-.766-.178-.207.334-.523-.122,1.219-1.879.578.134.267,2.224-.529-.122Zm-.039-.416-.08-.81-.426.693Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.928,125.542a.383.383,0,0,0-.123-.193.558.558,0,0,0-.232-.111.517.517,0,0,0-.426.07.622.622,0,0,0-.244.391.632.632,0,0,0,.05.479.574.574,0,0,0,.385.257.528.528,0,0,0,.334-.022.539.539,0,0,0,.248-.225l-.635-.148.086-.369,1.087.253-.108.466a1.014,1.014,0,0,1-.269.3,1.04,1.04,0,0,1-.4.182,1.082,1.082,0,0,1-.486-.008,1.1,1.1,0,0,1-.51-.259.955.955,0,0,1-.286-.456,1.109,1.109,0,0,1-.007-.57,1.125,1.125,0,0,1,.258-.512.968.968,0,0,1,.456-.285,1.1,1.1,0,0,1,.571-.009,1.085,1.085,0,0,1,.58.323.864.864,0,0,1,.221.571Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.35,125.611l-.1.416.668.155-.089.385-.669-.155-.1.45.756.176-.094.4-1.256-.292.477-2.052,1.256.292-.094.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.174,150.315c1.057.254,1.666-.4,1.355-1.465l-3.912-13.261c-.313-1.061-1.178-1.269-1.924-.462l-7.575,8.2c-.293-1-1.364-4.626-1.364-4.626-.313-1.061-1.178-1.269-1.923-.462l-3.848,4.166-1.139,1.233a1.067,1.067,0,0,0,.57,1.927Z",
    fill: "#e3ecfd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.286,134.037a2.8,2.8,0,0,0,2.043,3.367,2.747,2.747,0,0,0,3.3-2.051l.007-.031a2.8,2.8,0,0,0-2.044-3.367,2.745,2.745,0,0,0-3.294,2.055l-.006.027",
    fill: "#e3ecfd"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.732,
    height: 4.241,
    transform: "translate(176.185 40.092)",
    fill: "#2d4e73"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.732,
    height: 4.241,
    transform: "translate(176.185 32.028)",
    fill: "#2d4e73"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.241,
    height: 1.733,
    transform: "translate(170.895 37.318)",
    fill: "#2d4e73"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.25,
    height: 1.733,
    transform: "translate(178.959 37.318)",
    fill: "#2d4e73"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.654,92.019H73.34a9.862,9.862,0,0,0-1.149-2.865l.968-.968a.876.876,0,0,0,0-1.239L71.04,84.828a.876.876,0,0,0-1.239,0l-.93.93a9.932,9.932,0,0,0-2.839-1.216V83.175a.876.876,0,0,0-.876-.876h-3a.876.876,0,0,0-.876.876v1.316a9.96,9.96,0,0,0-2.866,1.147l-.967-.967a.876.876,0,0,0-1.239,0L54.089,86.79a.876.876,0,0,0,0,1.239l.932.932A9.819,9.819,0,0,0,53.805,91.8H52.437a.876.876,0,0,0-.876.876v3a.876.876,0,0,0,.876.876h1.319A9.751,9.751,0,0,0,54.9,99.414l-.968.968a.876.876,0,0,0,0,1.239l2.119,2.119a.876.876,0,0,0,1.239,0l.93-.93a9.914,9.914,0,0,0,2.836,1.216v1.366a.876.876,0,0,0,.876.876h3a.876.876,0,0,0,.876-.876v-1.316a9.777,9.777,0,0,0,2.863-1.146l.967.967a.876.876,0,0,0,1.239,0L73,101.778a.876.876,0,0,0,0-1.239l-.931-.931a9.843,9.843,0,0,0,1.219-2.836H74.65a.876.876,0,0,0,.876-.876v-3a.876.876,0,0,0-.876-.876M63.541,99.861a5.577,5.577,0,1,1,5.58-5.576,5.577,5.577,0,0,1-5.58,5.576h0",
    fill: "#e6edfc"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesConfirmImage);
export default __webpack_public_path__ + "static/media/images-confirm-image.23ffcc17e20e5633cada1af71f6b75af.svg";
export { ForwardRef as ReactComponent };